import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import {UtilitiesService} from '../Services/utilities.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate  {
  //canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   
  //}

  constructor(public auth: AuthService, public router: Router,public service:UtilitiesService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.auth.isAuthenticated() ) {
      this.router.navigate(['/home']);
      return false;
    }
    else
    {
      var reqmodel={EmpCode:this.service.GetLoginEmployeeCode()};
      this.service.PostRequestWithheader(this.service.Url+"Login/CheckAgentPaymentStatus",reqmodel).subscribe(resp=>{
        var res=this.service.ParseResponse(resp);
        if(res.Response.Status)
        {
          if(res.paymentHistory)
          {
                 this.service.IsDMS=res.paymentHistory.IsDMS;
          }
        }
       });
    }
    
    // else if(!this.service.CheckUserRight(url) )
    // {
    //   this.router.navigate(['/dashboard']);
    //   return false;
    // }
    return true;
  }
}
